export default __webpack_public_path__ + "3f7a5c5a0993a4637b0893693b9d733c.png";